import { Datagrid, DateField, List, NumberField, ShowButton, TextField } from "react-admin";

export const FileList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <NumberField source="id" />
            <TextField source="encoding" />
            <TextField source="filename" />
            <TextField source="mimetype" />
            <TextField source="originalname" />
            <NumberField source="size" />
            <TextField source="hash" />
            <DateField source="createdAt" />
            <DateField source="updatedAt" />
            <ShowButton />
        </Datagrid>
    </List>
);